export enum ReasonCodeEnum {
  TOO_TECHNICAL = 'too_technical',
  INCOMPLETE = 'incomplete',
  NOT_RELATED = 'not_related',
  INCORRECT_LINKS = 'incorrect_links',
  OTHER = 'other',
}
